var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CurrentIconColor2",
    d: "M16.4004 0.399902C15.5517 0.399902 14.7378 0.737044 14.1376 1.33716C13.5375 1.93728 13.2004 2.75121 13.2004 3.5999C13.2018 3.82484 13.227 4.04899 13.2754 4.26865L6.00977 7.90146C5.7101 7.55647 5.34002 7.27965 4.92443 7.08964C4.50883 6.89963 4.05736 6.80083 3.60039 6.7999C2.7517 6.7999 1.93777 7.13704 1.33765 7.73716C0.737532 8.33728 0.400391 9.15121 0.400391 9.9999C0.400391 10.8486 0.737532 11.6625 1.33765 12.2626C1.93777 12.8628 2.7517 13.1999 3.60039 13.1999C4.0575 13.1994 4.5092 13.1009 4.92508 12.9112C5.34095 12.7215 5.71135 12.4448 6.01133 12.0999L13.2723 15.7312C13.2249 15.9509 13.2008 16.1751 13.2004 16.3999C13.2004 17.2486 13.5375 18.0625 14.1376 18.6626C14.7378 19.2628 15.5517 19.5999 16.4004 19.5999C17.2491 19.5999 18.063 19.2628 18.6631 18.6626C19.2632 18.0625 19.6004 17.2486 19.6004 16.3999C19.6004 15.5512 19.2632 14.7373 18.6631 14.1372C18.063 13.537 17.2491 13.1999 16.4004 13.1999C15.9433 13.2004 15.4916 13.2989 15.0757 13.4886C14.6598 13.6783 14.2894 13.955 13.9895 14.2999L6.72852 10.6687C6.7759 10.4489 6.79999 10.2247 6.80039 9.9999C6.79885 9.77549 6.77372 9.55187 6.72539 9.33272L13.991 5.6999C14.2908 6.04462 14.661 6.32114 15.0766 6.51088C15.4921 6.70061 15.9435 6.79916 16.4004 6.7999C17.2491 6.7999 18.063 6.46276 18.6631 5.86264C19.2632 5.26253 19.6004 4.4486 19.6004 3.5999C19.6004 2.75121 19.2632 1.93728 18.6631 1.33716C18.063 0.737044 17.2491 0.399902 16.4004 0.399902Z",
    fill: "#D0D9E2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.8e9806144f7dc078262642282e740e23.svg";
export { ForwardRef as ReactComponent };